import React, { useState } from 'react';
import api from '../services/api';
import { Card, Form, Button, Alert, Container, Spinner, Badge } from 'react-bootstrap';
import { FaEnvelope, FaArrowLeft, FaPaperPlane } from 'react-icons/fa';

const ForgotPassword = ({ setCurrentView }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage(null);
        
        // Trim và chuyển về chữ thường để tránh lỗi chính tả/khoảng trắng khi gửi lên Server
        const cleanEmail = email.trim().toLowerCase();
        
        if (!cleanEmail) {
            setError("Vui lòng nhập địa chỉ Email.");
            return;
        }

        setLoading(true);

        try {
            // Gửi yêu cầu với email đã được làm sạch
            const res = await api.post('/api/auth/forgot-password', {
                email: cleanEmail 
            });
            
            if (res.data.success) {
                // Hiển thị thông báo thành công từ Server
                setMessage(res.data.message || 'Link khôi phục đã được gửi. Vui lòng kiểm tra email của bạn.');
            }
        } catch (err) {
            // Hiển thị lỗi chi tiết từ Server nếu có, nếu không hiển thị lỗi mặc định
            setError(err.response?.data?.message || 'Không thể gửi yêu cầu, vui lòng thử lại.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <Card className="shadow-lg border-0 animate__animated animate__fadeIn" style={{ maxWidth: '420px', width: '100%', borderRadius: '15px', overflow: 'hidden' }}>
                
                <div className="text-center p-4" style={{ background: 'linear-gradient(135deg, #111827 0%, #374151 100%)', borderBottom: '4px solid #ccac00' }}>
                    <Badge bg="warning" text="dark" className="mb-2 px-3 fw-bold text-uppercase">Security</Badge>
                    <h3 className="text-warning fw-black mb-0 text-uppercase" style={{ letterSpacing: '1px' }}>Khôi phục mật khẩu</h3>
                </div>

                <Card.Body className="p-4 bg-white text-dark">
                    <p className="text-muted small text-center mb-4 italic">
                        Nhập Email đăng ký. Chúng tôi sẽ gửi một liên kết bảo mật để bạn thiết lập lại mật khẩu mới.
                    </p>

                    {message && <Alert variant="success" className="small fw-bold border-0 shadow-sm text-center py-3">{message}</Alert>}
                    {error && <Alert variant="danger" className="small fw-bold border-0 shadow-sm text-center py-3">{error}</Alert>}
                    
                    {!message && (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold small text-muted text-uppercase">
                                    <FaEnvelope className="me-1"/> Địa chỉ Email
                                </Form.Label>
                                <Form.Control 
                                    type="email" 
                                    value={email} 
                                    onChange={(e) => setEmail(e.target.value)} 
                                    required 
                                    placeholder="your-email@example.com"
                                    // Thêm class này để đảm bảo giao diện input đẹp hơn
                                    className="shadow-sm shadow-none-focus"
                                    style={{ height: '50px', border: '2px solid #eee', borderRadius: '8px' }} 
                                    disabled={loading}
                                />
                            </Form.Group>

                            <Button 
                                variant="dark" 
                                type="submit" 
                                className="w-100 py-3 fw-black text-warning shadow border-0" 
                                disabled={loading}
                                style={{ borderRadius: '10px', letterSpacing: '1px', background: '#111827' }}
                            >
                                {loading ? (
                                    <><Spinner size="sm" animation="border" className="me-2" /> ĐANG XỬ LÝ...</>
                                ) : (
                                    <><FaPaperPlane className="me-2"/> GỬI LINK KHÔI PHỤC</>
                                )}
                            </Button>
                        </Form>
                    )}

                    <div className="text-center mt-4 pt-2 border-top">
                        <Button 
                            variant="link" 
                            onClick={() => setCurrentView('login')} 
                            className="text-decoration-none fw-bold p-0 mt-1 text-muted small"
                        >
                            <FaArrowLeft className="me-1"/> Quay lại trang Đăng nhập
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ForgotPassword;